// extracted by css-extract-rspack-plugin
var _1 = "error___WslD";
var _2 = "error--no-margin__j5QRC";
var _3 = "error--with-counter__lrTy8";
export { _1 as "error", _2 as "error--no-margin", _3 as "error--with-counter" }
export default { "error": _1, "error--no-margin": _2, "error--with-counter": _3 }
